import { CartContentProvider } from '@segments/Cart'
import * as React from 'react'

import { useFormOrderCtx } from '~shared/segments/FormScreen'

type TProps = RequiredChildren

/**
 * Wrapper for CartContentProvider on FormScreen.
 */
export const FormCartContentProvider: React.FC<TProps> = ({ children }) => {
  const order = useFormOrderCtx()

  if (!order) {
    return null
  }

  return <CartContentProvider orderId={order.id}>{children}</CartContentProvider>
}
